var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "apl_code" }, [
        _c(
          "div",
          { staticClass: "flex_box" },
          [
            _c("span", { staticClass: "lable" }, [
              _vm._v("手写签字校验关闭：")
            ]),
            _c("el-input", {
              staticClass: "input",
              attrs: {
                size: "small",
                placeholder: "请输入合同APL编号或批量签业务编号"
              },
              model: {
                value: _vm.aplCode,
                callback: function($$v) {
                  _vm.aplCode = $$v
                },
                expression: "aplCode"
              }
            }),
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.queryAplCodeFn }
              },
              [_vm._v("关闭")]
            )
          ],
          1
        ),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errorAplCodeTip,
                expression: "errorAplCodeTip"
              }
            ],
            staticStyle: { color: "#ec1c1c", "padding-left": "20px" }
          },
          [
            _c("span", { staticStyle: { color: "#ffffff" } }, [
              _vm._v("手写签字校验关闭： ")
            ]),
            _vm._v(
              "\n      未查询到合同，请确认APL编号或批量签业务编号是否正确！\n    "
            )
          ]
        ),
        _c("p", { staticClass: "tip" }, [
          _vm._v(
            "\n      提示：关闭后，当前合同个人签署方在进行手写签字时，无需校验手写签字与发起时填写的名称是否一致\n    "
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.closeAplCodeVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.closeAplCodeVisible = $event
            }
          }
        },
        [
          _c("p", [_vm._v("确定关闭当前合同手写签字校验？")]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.closeAplCodeVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.closeAplCodeFn }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4142a5c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4142a5c3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/signCheck.vue
// module id = tGFF
// module chunks = 0 28 34 48 59 215